import React from 'react';
import { useGeneralStore } from 'src/store';
import { AnimatedDots } from '@components/shared/animated-dots/AnimatedDots';

export const LayoutLoading = () => {
  const { isLoadingConfig } = useGeneralStore();

  return (
    <>
      {isLoadingConfig && <div className="z-[999999] fixed w-screen h-screen flex items-center justify-center bg-background transition-all">
        <AnimatedDots />
      </div>}
    </>
  );
};
